import VConsole from "vconsole";

import { isProduction } from "@/utils/constants";

let vConsole: VConsole | null = null;
if (!isProduction) {
  const instance = new VConsole({
    onReady() {
      instance.hideSwitch();
    },
    target: document.body,
  });

  vConsole = instance;
}

export { vConsole };
